export default __webpack_public_path__ + "static/media/Artboard3.e16431d8.png";